import { isDingdingMiniapp } from "../_utils/miniappEnvApp";
import { CONTAINER_NAME } from "../_utils/constant";
import { normalize } from "../common";
var saveImage = normalize.saveImage(function (args) {
  return isDingdingMiniapp ? dd.saveImage(args) : my.saveImage(args);
}, CONTAINER_NAME.ALIPAY);
export default saveImage;